import { OptionalGroupRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import { fn } from "util";

class DataTablePresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      resultSet: [],
      filters: {},
      order: {
        field: "name",
        direction: "ASC"
      },
      errorable: {
        visible: false,
        content: ""
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: 0
      }
    };
  }

  async onStart() {
    await this.load();
  }

  async load() {
    this.enqueue({ loading: true });

    const { pagination } = this.viewModel;
    const repositoryResult = await OptionalGroupRepository.getListOnline({
      order: [this.viewModel.order],
      pagination: {
        page: pagination.currentPage,
        perPage: pagination.perPage
      },
      filters: await this.getFilters()
    });

    if (repositoryResult.success) {
      this.enqueue(vm => ({
        resultSet: repositoryResult.data,
        pagination: {
          ...vm.pagination,
          total: repositoryResult.total,
          perPage: repositoryResult.perPage
        }
      }));
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Nosso serviço encontra-se indisponível. Tente novamente mais tarde."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não foi possível carregar os dados. Tente novamente mais tarde."
      });
    }

    this.enqueue({ loading: false });
  }

  onChangeSwitch(optGroupName, optGroupUuid, checked, error) {
    const message = checked ? "habilitar" : "desabilitar";
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja ${message} o grupo de opcionais ${optGroupName}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, eu tenho certeza",
          type: "accent",
          callback: () => this.changeSwitch(optGroupUuid, checked, error)
        }
      ]
    });
  }

  changeSwitch(optGroupUuid, checked, error) {
    const resultSet = this.viewModel.resultSet;
    const changedOptGroup = resultSet.filter(o => o.uuid === optGroupUuid);
    const indexOfUpdatedOptGroup = resultSet.findIndex(
      o => o.name === changedOptGroup[0].name
    );

    let newResultSet = resultSet;
    newResultSet[indexOfUpdatedOptGroup].enabled = checked;

    this.updateResultSet(newResultSet, indexOfUpdatedOptGroup, checked, error);
  }

  async updateResultSet(resultSet, indexOfUpdatedOptGroup, checked, error) {
    this.enqueue({
      resultSet
    });
    if (!error) {
      await this.callRepository(indexOfUpdatedOptGroup, checked);
    }
  }

  async callRepository(indexOfOptGroup, checked) {
    this.enqueue({ loading: true });
    const resultSet = this.viewModel.resultSet;
    const optionalGroup = resultSet[indexOfOptGroup];

    const optionalGroupUuid = optionalGroup.uuid;
    const result = await OptionalGroupRepository.updateOptionalGroup(
      optionalGroupUuid,
      optionalGroup
    );
    if (!result.success) {
      const enable = checked ? "Habilitar" : "Desabilitar";
      const error = true;

      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: `Ocorreu um erro e não foi possível ${enable} o grupo de opcionais. Tente novamente mais tarde.`
      });

      setTimeout(
        () => this.onChangeSwitch(optionalGroupUuid, !checked, error),
        300
      );
    }
    this.enqueue({ loading: false });
  }

  async getFilters() {
    const name = this.props.filter.name ? this.props.filter.name : "";
    const filters = [
      { connector: "AND", field: "deleted", operation: "NOT", value: true }
    ];

    if (!fn.isBlank(name)) {
      filters.push({
        connector: "AND",
        field: "name",
        operation: "LIKE",
        value: name
      });
    }

    return filters;
  }

  async onFilterChange(fields) {
    this.enqueue({ filters: fields });
    await this.load();
  }

  onPageChange(page) {
    this.enqueue(
      vm => ({
        pagination: {
          ...vm.pagination,
          currentPage: page
        }
      }),
      () => this.load()
    );
  }

  onOrderChange(field, direction) {
    this.enqueue(
      vm => ({
        order: {
          ...vm.order,
          field,
          direction
        }
      }),
      () => this.load()
    );
  }

  async onViewOptionalGroup(optionalGroup) {
    this.navigateTo("app.registration.optional_group.info", {
      optionalGroupUuid: optionalGroup.uuid
    });
  }

  async onEditOptionalGroup(optionalGroup) {
    this.navigateTo("app.registration.optional_group.edit", {
      optionalGroupUuid: optionalGroup.uuid
    });
  }

  async onDeleteOptionalGroup(optionalGroup) {
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o grupo de opcionais ${optionalGroup.name ||
        "Sem nome"}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDeleteOptionalGroup(optionalGroup)
        }
      ]
    });
  }

  async doDeleteOptionalGroup(optionalGroup) {
    this.enqueue({ loading: true });

    const repositoryResult = await OptionalGroupRepository.deleteOptionalGroup(
      optionalGroup.uuid,
      optionalGroup
    );

    if (repositoryResult.success) {
      await this.load();
      this.sendNotification({
        type: "success",
        content: "O grupo de opcionais foi excluído."
      });
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: "Ocorreu um erro na conexão. Tente novamente mais tarde."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: repositoryResult.error
      });
    }

    this.enqueue({ loading: false });
  }
}

export default DataTablePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/list/data-table/presenter.js